// A file for variables shared across data modules, to avoid circular dependencies.

export const actionTypes = {
  SET_GROUP_USERS: 'SET_GROUP_USERS', // Used by both group and user reducers, triggered from group.js
  SET_GROUP_TEAMS: 'SET_GROUP_TEAMS', // Used by both group and team reducers, triggered from group.js
};
